<template>
  <div
    v-if="hasErrors"
    class="alert-view">
    <strong>{{ title }}</strong>
    <ul
      v-for="(messages, key) in visibleErrors"
      :key="key">
      <li
        v-for="(message, index) in messages"
        :key="index">
        <span
          v-for="(sentence,idx) in message.split(/\n/)"
          :key="idx">
          {{ sentence }}<br>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AlertView',
  props: {
    title: {
      type: String,
      default() {
        return '下記項目に誤りがあります。\nご確認の上、正しく入力し直してください。'
      },
    },
    errors: {
      type: [Object, Array],
      required: true,
    },
  },
  computed: {
    hasErrors() {
      return Object.keys(this.visibleErrors).length > 0
    },
    visibleErrors() {
      const errors = { ...this.errors }
      delete errors.confirmed
      return errors
    },
  },
}
</script>
